import { createI18n } from 'vue-i18n'

import it from './locale/it.js'
import fr from './locale/fr.js'
import pl from './locale/pl.js'
import hy from './locale/hy.js'
import uk from './locale/uk.js'
import ru from './locale/ru.js'
import zh from './locale/zh.js'

const i18n = createI18n({
  legacy: false,
  locale: 'it',
  fallbackLocale: 'it',
  messages: {
    it,
    fr,
    pl,
    hy,
    uk,
    ru,
    zh
  },
  globalProperties: true
})

export const originalText = `Altissimu, onnipotente, bon Signore, tue sò le
laude, la gloria e l’honore et onne
benedictione. Ad Te solo, Altissimo, se
konfane et nullu homo ène dignu Te mentovare.

Laudato sie, mi Signore, cum tutte le Tue
creature, spetialmente messer lo frate sole, lo
qual è iorno, et allumini noi per lui. Et ellu è
bellu e radiante cum grande splendore: de Te,
Altissimo, porta significatione.

Laudato sì, mi Signore, per sora luna e le
stelle: in celu l’ài formate clarite e pretiose e
belle.

Laudato sì, mi Signore, per frate vento e per
aere e nubilo e sereno et onne tempo, per lo
quale a le Tue creature dài sustentamento.

Laudato sì, mi Signore, per sor’acqua, la quale è
multo utile et humile e pretiosa e casta.

Laudato sì, mi Signore, per frate focu, per lo
quale ennallumini la nocte, et ello è bello e
iocundo e robustoso e forte.

Laudato sì, mi Signore, per sora nostra matre
terra, la quale ne sustenta e governa, e produce
diversi fructi con coloriti flori et herba.

Laudato sì, mi Signore, per quelli ke
perdonano per lo Tuo amore, e sostengo
infirmitate e tribulatione. Beati quelli ke ‘l
sosterrano in pace, ka da Te, Altissimo, sirano
incoronati.

Laudato sì, mi Signore, per sora nostra morte
corporale, da la quale nullu homo vivente pò
skapare: guai a quelli ke morrano ne le
peccata mortali; beati quelli ke trovarà ne le tue
sanctissime voluntati, ka la morte secunda no ‘l
farrà male.

Laudate e benedicete mi Signore e ringratiate e
serviateli cum grande humilitate.`
export default i18n